import React, { useState } from "react";
import styles from "./Experience.module.css";
import skillsData from "../../data/skills.json";
import experience from "../../data/experience.json";
import OrgImage1 from "../../assets/experience/Accenture.png";
import OrgImage2 from "../../assets/experience/Dotchat.png";
import OrgImage3 from "../../assets/experience/Publicis_Sapient.png";
import removeMiddleSpaces from "../../utils";
import { Calendar } from "../common/Icons";
import LiquidGlass from "../common/LiquidGlass";
import Reveal from "../common/Reveal";
import SectionIntro from "../common/SectionIntro";

const OrgImages = [OrgImage1, OrgImage2, OrgImage3];

const skillCategories = [
  { id: "all", label: "All" },
  { id: "frontend", label: "Frontend" },
  { id: "state-ui", label: "State & UI" },
  { id: "backend", label: "Backend" },
];

const categorizeSkill = (title) => {
  const t = title.toLowerCase();
  if (t.includes("node") || t.includes("express") || t.includes("mern")) return "backend";
  if (
    t.includes("zustand") ||
    t.includes("redux") ||
    t.includes("tailwind") ||
    t.includes("shadcn") ||
    t.includes("material")
  )
    return "state-ui";
  return "frontend";
};

const hideBrokenImage = (e) => {
  e.target.style.visibility = "hidden";
};

const Experience = () => {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredSkills = skillsData.filter((skill) => {
    if (activeCategory === "all") return true;
    return categorizeSkill(skill.title) === activeCategory;
  });

  return (
    <section className={styles.container} id="experience">
      <SectionIntro
        index="02"
        label="Experience"
        title="Where the work happened."
        lede="Three teams, three very different constraint sets: regulated healthcare, a consumer gifting product, and luxury retail at scale."
      />

      <div className={styles.columns}>
        <ol className={styles.ledger}>
          {experience.map((item, id) => (
            <Reveal as="li" key={item.organisation} className={styles.entry} delay={id * 80}>
              <div className={styles.entryTop}>
                <span className={styles.logo}>
                  <img src={OrgImages[id]} alt="" loading="lazy" onError={hideBrokenImage} />
                </span>
                <h3 className={styles.role}>{item.role}</h3>
                <span className={styles.org}>{item.organisation}</span>
                <span className={styles.dates}>
                  <Calendar size={13} />
                  {`${item.startDate} - ${item.endDate}`}
                </span>
              </div>

              <ul className={styles.points}>
                {item.experiences.map((point) => (
                  <li key={point} className={styles.point}>
                    <span className={styles.dash} aria-hidden="true" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </ol>

        <Reveal
          as={LiquidGlass}
          className={styles.skills}
          blur="soft"
          wash
          delay={120}
          aria-label="Toolkit"
        >
          <div className={styles.skillsHead}>
            <h3 className={styles.skillsTitle}>Toolkit</h3>
            <span className={styles.skillsCount}>
              {filteredSkills.length} of {skillsData.length}
            </span>
          </div>

          <div className={styles.filters}>
            {skillCategories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActiveCategory(cat.id)}
                className={`${styles.filterBtn} ${
                  activeCategory === cat.id ? styles.filterActive : ""
                }`}
                aria-pressed={activeCategory === cat.id}
              >
                {cat.label}
              </button>
            ))}
          </div>

          <ul className={styles.skillList}>
            {filteredSkills.map((skill) => (
              <li key={skill.title} className={styles.skill}>
                <span className={styles.skillMark} aria-hidden="true">
                  <img
                    src={`./assets/skills/${removeMiddleSpaces(skill.title)}.png`}
                    alt=""
                    loading="lazy"
                    onError={hideBrokenImage}
                  />
                </span>
                <span className={styles.skillBody}>
                  <span className={styles.skillName}>{skill.title}</span>
                  {skill.tagline && <span className={styles.skillNote}>{skill.tagline}</span>}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default Experience;